<template>
	<div>
        <div class="flex justify-between items-center border-b border-gray-300 pb-1 mb-3">
            <h1 class="module-header">Building Fields</h1>
        </div>
        
        <div class="p-6 bg-gray-100 border shadow-md clearfix">
            <div class="flex justify-around mb-8 text-blue-600">
                <div
                    v-for="type in buildingTypes" :key="type"
                    @click="activeBuildingType = type"
                    class="flex-1 text-center cursor-pointer p-6 mx-3 border border-blue font-semibold hover:bg-blue-300 hover:text-white"
                    :class="activeBuildingType == type ? 'bg-blue-500 text-white' : 'bg-white'">
                    {{ type }}
                </div>
            </div>
            <div class="flex">
                <div class="flex-1 mr-16">
                    <h2 class="text-base border-b border-dotted border-gray-300 pb-2 mb-2">Fields Assigned</h2>
                    <div class="bg-white shadow p-4">
                        <draggable
                            class="flex flex-wrap"
                            v-if="this.activeBuildingType"
                            v-model="usedFields"
                            :options="{ group: 'fields' }">
                            <div
                                v-for="(field, fieldIndex) in usedFields" :key="fieldIndex"
                                class="w-1/5 draggable-item"
                            >{{ field.label }}</div>
                        </draggable>
                        <div v-else class="text-xs">
                            Please select a Property Type above
                        </div>
                    </div>

                    <button v-if="this.activeBuildingType" class="btn btn-green mt-3" @click="saveFields">Save</button>
                </div>

                <div style="flex: 0; min-width: 25%">
                    <h2 class="text-base border-b border-dotted border-gray-300 pb-2 mb-2">Available Fields</h2>
                    <div class="bg-white shadow p-4 overflow-y-auto" style="max-height: 650px;">
                        <draggable
                            class="flex flex-col"
                            v-if="this.activeBuildingType"
                            v-model="availableFields"
                            :options="{ group: 'fields', ghostClass: 'sortable-ghost-small' }">
                            <div
                                v-for="(field, fieldIndex) in availableFields" :key="fieldIndex"
                                class="w-full draggable-item"
                            >{{ field.label }}</div>
                        </draggable>
                        <div v-else class="text-xs">
                            Please select a Property Type above
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <notifications classes="notification" position="bottom right"></notifications>
	</div>
</template>

<script>
    import draggable from 'vuedraggable'
    
    export default {
    	props: ['all-fields', 'fields', 'buildingTypes', 'buildingType'],
        
        components: {
            draggable,
        },

    	data() {
    		return {
                activeBuildingType: this.buildingType,
                fieldData: this.fields,
    		}
    	},

        computed: {
            usedFields: {
                get: function () {
                    return _.flatten(_.map(this.fieldData[this.activeBuildingType], (field) => { return field; }));
                },
                set: function (newValue) {
                    this.fieldData[this.activeBuildingType] = newValue;
                }
            },

            availableFields() {
                return _.reject(this.allFields, (field) => {
                    return _.find(this.usedFields, ['id', field.id]);
                }).sort((a, b) => {
                    return a.label < b.label ? -1 : 1;
                });
            }
        },

        methods: {
            setSortOrders() {
                _.flatMap(this.fieldData, (fields) => {
                    return _.map(fields, (field, index) => {
                        field.pivot = field.pivot || {};
                        field.pivot.sort_order = index + 1;
                    });
                });
            },

            saveFields() {
                const self = this;

                if (! this.activeBuildingType) {
                    return;
                }

                this.setSortOrders();

                axios.patch('/api/building/fields', { fields: this.fieldData })
                    .then((response) => {
                        self.$notify({
                            type: 'success',
                            title: 'Success',
                            text: response.data.message
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        }
    }
</script>